import React from 'react'
import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

// 2026-10-27 coder(lq): 常规说明按需展开，不占整行；保留键盘聚焦和触屏点击入口。
export default function HelpHint({ label, children }) {
    return <Tooltip title={children} trigger={['hover', 'focus', 'click']}>
        <button type="button" className="menu-api-help" aria-label={label}>
            <QuestionCircleOutlined aria-hidden="true" />
        </button>
    </Tooltip>
}
